<template>
    <div id="aTable" :class="['dyn-filter', {'loading': loading }]">
        <button @click.stop="applyFilter()" v-if="!filterRows.length" type="button" class="btn">Добавить фильтр</button>
        <div class="dyn-filter-rows flex">
            <div style="width:100%">
                <template v-for="(row, i) of filterRows">
                    <div :id="'dfRow' + i" class="dyn-filter-row">
                        <div class="dyn-filter-field">
                            <drop-down v-if="row != null"
                                       :items="getNotUsedFilters(row.FilterValue)"
                                       :dataField="'Value'"
                                       :textField="'Name'"
                                       v-model="row.FilterValue"
                                       :name="'filter_' + row.Index"
                                       :key="'filter_' + row.Index"
                                       @change="onFilterChange(row, $event, i)"></drop-down>

                        </div>
                        <div class="dyn-filter-values">
                            <div v-for="(valueObj, j) of row.values" @click="onRemoveFilterValue(valueObj, i, j)" class="dyn-filter-values-selected">
                                {{valueObj.Name}}
                            </div>
                            <input v-if="row.Selected"
                                   :ref="'filterInput' + i"
                                   @input="onFilterInputChange(row, $event.target, i)"
                                   @click.stop=""
                                   class="dyn-filter-values-input" type="text">
                            <svg class="svg-icon plus" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" @click.stop="onAddFilterValue(row, i)" style="display: inline-block;">
                                <use xlink:href="/Content/dist/image_svg.svg#Plus"></use>
                            </svg>
                        </div>
                        <div class="dyn-filter-btns">
                            <img v-if="(i === filterRows.length - 1) && notUsedFilters.length" @click="onFilterRowAdd()" class="dyn-filter-plus" src="../../img/IconPlus32.png" alt="добавить фильтр">
                            <img @click="onFilterRowRemove(row, i)" class="dyn-filter-minus" src="../../img/IconDelete32.png" alt="удалить фильтр" style="display: block;">
                        </div>
                        <div id="dfValues1227" class="dyn-filter-values-select" @scroll="onScroll"
                             style="min-height: 30px;"
                             :style="{width: 1529 + 'px', top: (45 + i*35) + 'px', left: row.resultListLeftPos + 'px'}"
                             v-if="row.Selected"
                             :ref="'filterResults' + i">
                            <p class="dyn-filter-select-value"
                               v-for="res of getUniqueSearchResults(row)"
                               @click.stop="onSearchResultClick(row, res, i)"
                               style="">{{ res.Name }}</p>
                            <p v-if="getUniqueSearchResults(row).length === 0 && !loading" class="dyn-filter-select-novalue">
                                Нет значений
                            </p>
                        </div>
                    </div>
                </template>
            </div>
            <div style="width:35px;min-width:35px" class="margin-left-5" v-if="filterRows.length && cacheKey">
                <button type="button" class="btn" @click="onCancelClick" title="Очистить">
                    <img src="../../img/icon-del.png" alt="">
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import _ from 'lodash'
    import UI from '../helpers/ui-helpers'

    export default {
        name: "complex-filter",

        props: ['filters', 'searchFunction', 'tableName', 'withTableNameInClause', 'cacheKey', 'getByIdFilters'],

        data(){
            return {
                filterRows: [

                ],
                searchResults: [],
                index: 0,

                page: 1,
                loading: false,
                canBeLoaded: true,
                currentRow: null,
                currentTarget:null,
                currentI: null
            }
        },

        computed:{
            notUsedFilters(){
                let vm = this;

                return _.filter(vm.filters, function (item, index) {
                   return !_.some(vm.filterRows, {FilterValue: item.Value});
                });
            },

            exportData(){
                let vm = this;
                let data = [];
                for(let r of vm.filterRows){
                    if(r.values.length) {
                        let operand = 'IN';

                        let forceGettingById = false;
                        if(vm.getByIdFilters && vm.getByIdFilters.findIndex(x => x === r.FilterValue) > -1)
                        {
                            forceGettingById = true;
                        }
                        data.push([
                            vm.withTableNameInClause ? vm.tableName + '.[' + r.FilterValue + ']' : r.FilterValue,
                            operand,
                            '(' + r.values.map(function (item) {
                                if(forceGettingById)
                                {
                                    return `'${item.Id}'`;
                                }
                                else {
                                    return `'${(r.FilterValue.indexOf('TradePointRole_') !== -1 || r.FilterValue.indexOf('UserRole') !== -1 || r.FilterValue.indexOf('Month') !== -1) ? item.Id : encodeURIComponent(item.Name).replace("'", "''")}'`;
                                }
                            }).join(';') + ')'
                        ])
                    }
                }
                return data;
            }
        },

        methods: {

            getNotUsedFilters(filterValue){
                let vm = this;
                return _.filter(vm.filters, function (item, index) {
                    return !_.some(vm.filterRows, {FilterValue: item.Value}) || (filterValue && item.Value === filterValue);
                });
            },

            getUniqueSearchResults(row){
                return _.filter(this.searchResults, function (item) {
                    //console.info('getUniqueSearchResults -> row.values, item.Id, item.Name', row.values, item.Id, item.Name)
                    //return !_.includes(row.values, item) && item !== '';
                    return (item.Name !== '') && !_.some(row.values, (x) => (item.Id  != null && x.Id === item.Id) || (x.Name === item.Name) );
                });
            },

            applyFilter(){
              this.filterRows.push({
                  values: [],
                  Selected: false,
                  Index: ++this.index,
                  PreviousFilterValue: this.filters[0].Value
              });
            },

            // todo:
            recalculateLeftPos(){
                let vm = this;

                vm.$nextTick(() => {

                });
            },

            // выбор колонки для фильтрации
            onFilterChange(row, item, index){
                //console.info('row.FilterValue:', row.FilterValue)
                if(row.FilterValue !== row.PreviousFilterValue) {
                    row.PreviousFilterValue = row.FilterValue
                    this.filterRows.splice(index + 1);

                    if (row.values.length) {
                        row.values = [];
                        this.$emit('onFilterChange', this.exportData);
                    }
                }else{
                    row.values = [];
                    this.$emit('onFilterChange', this.exportData);
                }
                this.saveFilterState();
            },

            // удаление выбранного значения из строки фильтра
            onRemoveFilterValue(value, i, j){
                this.filterRows[i].values.splice(j, 1);

                // кроме этого удаляем все фильтры ниже
                this.filterRows.splice(i + 1, 100);

                this.$emit('onFilterChange', this.exportData);
                this.recalculateLeftPos();
                this.saveFilterState();
            },

            onAddFilterValue(row, i){
                let vm = this;

                row.Selected = true;
                vm.searchResults = [];

                vm.$nextTick(() => {
                    vm.$refs['filterInput' + i][0].focus();

                    //console.info('onAddFilterValue');

                    vm.currentRow = row;
                    vm.currentTarget = vm.$refs['filterInput' + i][0];
                    vm.currentI = i;
                    vm.page = 1;
                    vm.loading = false;
                    vm.canBeLoaded = true;
                    vm.searchNext(row, vm.$refs['filterInput' + i][0], i);
                });

                this.recalculateLeftPos();
            },

            // новый фильтр
            onFilterRowAdd(){
                let vm = this;

                vm.filterRows.push({
                    values: [],
                    Selected: false,
                    Index: ++vm.index
                });
                this.saveFilterState();
            },

            // удаление фильтра
            onFilterRowRemove(row, i){
                this.filterRows.splice(i, 1);

                this.$emit('onFilterChange', this.exportData);
                this.saveFilterState();
            },

            // выбор результата из поиска
            onSearchResultClick(row, res, i){
                row.values.push(res);

                if(row.values.length === 1){
                    // было выбрано первое значение, если есть фильтры ниже - их нужно удалить
                    this.filterRows.splice(i + 1, 100);
                }

                this.$emit('onFilterChange', this.exportData);

                this.recalculateLeftPos();
                this.saveFilterState();

                row.Selected = false;
            },

            filterRowSetValues(values){
                if(this.filterRows.length){
                    this.filterRows[0].values = values;
                }
            },

            // ввод символов в строке фильтра
            onFilterInputChange: _.debounce(function (row, e, i) {

                this.searchResults = [];
                this.searchNext(row, e, i);

            }, 500),

            getFilterForSearch(i){
                let vm = this;
                let data = [];
                let index = 0;
                for(let r of vm.filterRows){
                    if(index < i) {
                        if (r.values.length) {
                            let operand = 'IN';

                            let forceGettingById = false;
                            if (vm.getByIdFilters && vm.getByIdFilters.findIndex(x => x === r.FilterValue) > -1) {
                                forceGettingById = true;
                            }
                            data.push([
                                vm.withTableNameInClause ? vm.tableName + '.[' + r.FilterValue + ']' : r.FilterValue,
                                operand,
                                '(' + r.values.map(function (item) {
                                    if (forceGettingById) {
                                        return `'${item.Id}'`;
                                    }
                                    else {
                                        return `'${(r.FilterValue.indexOf('TradePointRole_') !== -1 || r.FilterValue.indexOf('UserRole') !== -1 || r.FilterValue.indexOf('Month') !== -1) ? item.Id : encodeURIComponent(item.Name).replace("'", "''")}'`;
                                    }
                                }).join(';') + ')'
                            ])
                        }
                    }
                    index++;
                }
                return data;
            },

            searchNext(row, e, i, addValues){
                let vm = this;

                vm.loading = true;
                // let filter = JSON.parse(JSON.stringify(vm.exportData));
                // if (filter.length) {
                //     filter.splice(i - (vm.filterRows.length - filter.length), 100)
                // }
                let filter = this.getFilterForSearch(i);
                //console.info('filter', filter);

                vm.searchFunction(vm.tableName, row.FilterValue, e.value, filter, vm.page, function (res) {
                    if(!addValues){
                        vm.searchResults = [];
                    }
                    let arr = [];
                    for(let item of res)
                    {
                        if(typeof item === 'string'){
                            arr.push({
                                Id: item,
                                Name: item
                            });
                        }
                        else{
                            arr.push(item);
                        }
                    }
                    if(arr.length) {
                        vm.searchResults.push(...arr);
                    }
                    else{
                        vm.canBeLoaded = false;
                    }

                    vm.loading = false;
                }, function(err){
                    vm.loading = false;
                    UI.toastr.error('Ошибка поиска' + (err ? ': ' + err : ''));
                });
            },

            onScroll(e){
                let vm = this;

                if (!vm.loading && vm.canBeLoaded) {
                    let elem = $(e.target);
                    //console.info('onScroll', elem[0].scrollHeight - elem.scrollTop(), elem.outerHeight());
                    if (elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                        vm.page++;
                        //console.info('need to search');
                        vm.searchNext(vm.currentRow, vm.currentTarget, vm.currentI, true);
                    }
                }
            },

            clear(){
                this.filterRows = [];
                this.saveFilterState();
            },

            onCancelClick(){
                this.filterRows = [];
                this.saveFilterState();
                this.$emit('onFilterChange', this.exportData);
            },

            getExpotData(){
                return this.exportData;
            },

            saveFilterState(){
                //console.info('saveFilterState', this.cacheKey);
                localStorage.setItem(this.cacheKey, JSON.stringify(this.filterRows));
            },

            getFilterState(){
                if(this.cacheKey){
                    return JSON.parse(localStorage.getItem(this.cacheKey));
                }
                return null;
            }
        },

        mounted(){
            let vm = this;

            let filterState = (this.getFilterState() || []).filter(x => {
               return vm.filters.find(y => y.Value === x.FilterValue);
            });
            vm.filterRows = filterState;

            for(let row of vm.filterRows){
                row.Selected = false;
            }

            vm.$nextTick(() => {

                $('body').on('click', function () {
                    for (let row of vm.filterRows) {
                        row.Selected = false;
                    }
                });

            });

            vm.index = 0;
        },

        destroyed() {
            $('body').off('click');
            $(document).find('.dyn-filter-values-select').off('scroll');
        }
    }
</script>

<style scoped>
    .svg-icon.plus {
        margin: 0 0 0 10px;
        width: 20px; height:20px
    }
</style>


// WEBPACK FOOTER //
// Content/src/components/ComplexFilter.vue